import React from "react";
import PropTypes from "prop-types";
import parse from "html-react-parser";
import {
  DescriptionWrapper,
  DescriptionHeader,
  DescriptionContent,
} from "./styles/description-styles";

const Description = ({ about }) => (
  <DescriptionWrapper>
    <DescriptionHeader>Description</DescriptionHeader>
    <DescriptionContent>{about ? parse(about) : "No data"}</DescriptionContent>
  </DescriptionWrapper>
);

Description.propTypes = {
  about: PropTypes.string,
};

Description.defaultProps = {
  about: PropTypes.isNull,
};

export default React.memo(Description);
